import { v4 as uuidV4 } from 'uuid';

export const ENQUEUE_SNACKBAR = 'ENQUEUE_SNACKBAR';
export const CLOSE_SNACKBAR = 'CLOSE_SNACKBAR';
export const REMOVE_SNACKBAR = 'REMOVE_SNACKBAR';

const DEFAULT_OPTIONS = {
    anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'center',
        }
    };

export const enqueueSnackbar = (notification) => {
    const key = notification.options && notification.options.key;
    return {
        type: ENQUEUE_SNACKBAR,
        notification: {
            ...notification,
            key: key || uuidV4(),
        },
    };
};

export const addErrorMessage = (message, options = {}) => {
    return enqueueSnackbar({
        message,
        options: {
            ...DEFAULT_OPTIONS,
            variant: 'error',
            ...options,
        },
    });
};

export const addWarningMessage = (message, options = {}) => {
    return enqueueSnackbar({
        message,
        options: {
            ...DEFAULT_OPTIONS,
            variant: 'warning',
            ...options,
        },
    });
};

export const addSuccessMessage = (message, options = {}) => {
    return enqueueSnackbar({
        message,
        options: {
            ...DEFAULT_OPTIONS,
            variant: 'success',
            ...options,
        },
    });
};

export const addInfoMessage = (message, options = {}) => {
    return enqueueSnackbar({
        message,
        options: {
            ...DEFAULT_OPTIONS,
            variant: 'info',
            ...options,
        },
    });
};

export const closeSnackbar = key => ({
    type: CLOSE_SNACKBAR,
    dismissAll: !key, // dismiss all if no key has been defined
    key,
});

export const removeSnackbar = key => ({
    type: REMOVE_SNACKBAR,
    key,
});